/**
 * CustomTooltip
 *
 * A styled wrapper around MUI Tooltip with a dark, square style and no arrow.
 * Used across table cells to display full content on hover when truncated.
 */
import React from "react";
import { styled } from "@mui/material/styles";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";

const CustomTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "rgba(80, 80, 80, 0.9)",
    borderRadius: "0px",
  },
  [`& .${tooltipClasses.arrow}`]: {
    display: "none",
  },
}));

export default CustomTooltip;
